import { yupResolver } from '@hookform/resolvers/yup';
import { kebabCase } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { InferType } from 'yup';

import { FormError } from '../../../data/utils/form.utils';
import { schema } from './schema';

export function useTemplateForm() {
  const values = useMemo(() => schema.getDefault(), []);

  const resolver = useMemo(() => yupResolver(schema), []);

  const form = useForm<InferType<typeof schema>>({
    resolver,
    defaultValues: values,
    mode: 'onBlur',
  });

  const intl = useIntl();

  const setErrors = useCallback(
    (errors: FormError[] | null | undefined) => {
      if (errors) {
        errors.forEach(error => {
          const name = error.fieldName as keyof InferType<typeof schema>;

          form.setError(name, {
            message: intl.formatMessage({
              id: `common.errors.${kebabCase(error.message)}`,
              defaultMessage: error.message,
            }),
          });
        });

        return false;
      }

      return true;
    },
    [form, intl]
  );

  return {
    form,
    formIsValid: useMemo(() => form.formState.isValid, [form.formState]),
    setErrors,
  };
}
